export class RatingFeedback {
  question: string;
  rate: number;
  constructor(question: string, rate: number) {
    this.question = question;
    this.rate = rate;
  }
}
